<template>
  <teleport to="#modals">
    <Modal class="modal modal--mob modal-discreet-payment" :size="'small'">
      <template #body>
        <div class="icon-wrapper">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#3B6D11"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="3" y="11" width="18" height="11" rx="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
        </div>
        <h1>
          {{ $t("credits.redirecting_title_line_1") }}
          {{ $t("credits.redirecting_title_line_2") }}
        </h1>
        <p>{{ $t("credits.redirecting_subtitle") }}</p>
        <br />
        <div class="processing w-100">
          <!-- Processing -->
          <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </div>

        <div class="security-bar">
          <div class="item">
            <svg
              width="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#999"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="11" width="18" height="11" rx="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
            {{ $t("credits.ssl_secured") }}
          </div>
          <div class="item">
            <svg fill="none" width="16" viewBox="0 0 24 24">
              <path
                stroke="#999"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M20 6h-1a9.6 9.6 0 0 1-7-3 9.6 9.6 0 0 1-7 3H4v3.17C4 14.86 7.4 19.64 12 21c4.6-1.36 8-6.14 8-11.83z"
              />
            </svg>
            {{ $t("credits.pci_compliant") }}
          </div>
          <div class="item">
            <svg fill="none" width="16" viewBox="0 0 24 24">
              <path
                stroke="#999"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 7v5l-1.5 2.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
              />
            </svg>
            {{ $t("credits.instant_redirect") }}
          </div>
        </div>
      </template>
    </Modal>
  </teleport>
</template>

<script>
import Modal from "@/components/generic/Modal.vue";

export default {
  name: "PaymentRedirectModal",
  components: { Modal },
};
</script>

<style scoped lang="scss">
.modal-discreet-payment {
  h1 {
    text-align: center;
    margin-bottom: 15px;
  }

  p {
    text-align: center;
    line-height: 1.3;
  }

  .processing {
    display: flex;
    justify-content: center;
  }
}

.security-bar {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding: 15px 0;
}

.item {
  text-align: center;
  color: #999;
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 5px;
  width: 33.33%;
  padding: 0 5px;
}

.icon-wrapper {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: #eaf3de;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 15px;
}

.spinner {
  margin: 0 0 20px;
  width: 70px;
  text-align: center;
  //   transform: translate(-9px, 3px);

  > div {
    width: 16px;
    height: 16px;
    background-color: #3b6d11;
    border-radius: 100%;
    display: inline-block;
    animation: sk-bouncedelay 1.6s infinite ease-in-out both;
  }
  .bounce1 {
    animation-delay: -0.32s;
  }
  .bounce2 {
    animation-delay: -0.16s;
  }
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(0.6);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(0.6);
  }
}
</style>